import { render } from "./table-snippet.vue?vue&type=template&id=5c32d2d5"
import script from "./table-snippet.vue?vue&type=script&lang=js"
export * from "./table-snippet.vue?vue&type=script&lang=js"

import "./table-snippet.vue?vue&type=style&index=0&id=5c32d2d5&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__